import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isDate } from 'date-fns';
import classNames from 'classnames';

import AdditionalContent from './presentational/additional_content';
import BookBtn from './presentational/book_btn';
import ExpandBtn from './presentational/expand_btn';
import RichText from './presentational/richtext';
import Time from './presentational/time';

const stripTags = txt => txt.replace(/(<([^>]+)>)/gi, '');

export default class Session extends Component {
  static propTypes = {
    additional: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    session: PropTypes.object.isRequired,
  };

  state = {
    expanded: false,
  };

  expandBtn = (className, key) => <ExpandBtn key={key} className={className} onClick={this.expand} />;

  sessionTime = (session, className, wrapper, key) => (
    <Time {...session} wrapper={wrapper} className={className} key={key} />
  );

  wrapperItem = (title, wrapper, className, key) => (
    <div className={className} key={key}>
      <div className={wrapper}>
        <RichText content={title} />
      </div>
    </div>
  );

  columnItem = (title, className, key) => (
    <div className={className} key={key}>
      {title}
    </div>
  );

  expand = e => {
    e.preventDefault();
    this.setState(prevState => {
      const { expanded } = prevState;
      return { expanded: !expanded };
    });
  };

  itemType = (session, key, wrapper) => {
    if (isDate(session[key])) return 'time';
    // if (key === 'session') return key;
    if (key === 'expand' || key === 'actions') return key;
    if (wrapper) return 'wrapper';
    return 'normal';
  };

  _renderItems() {
    const { columns, session } = this.props;
    return columns.map(({ key, className, wrapper }) => {
      const compKey = `${key}-${session.isRequired}`;
      switch (this.itemType(session, key, wrapper)) {
        case 'time':
          return this.sessionTime(session, className, wrapper, compKey);
        case 'expand':
          return this.expandBtn(className, compKey);
        case 'wrapper':
          return this.wrapperItem(session[key], wrapper, className, compKey);
        default:
          return this.columnItem(session[key], className, compKey);
      }
    });
  }

  render() {
    const { additional, session } = this.props;
    const { expanded } = this.state;
    return (
      <div className="clearfix tr">
        {this._renderItems()}
        <div className="col-lg-2 col-md-2 mb mb-actions center">
          <BookBtn session={session} />
        </div>
        <AdditionalContent additional={additional} expanded={expanded} session={session} />
      </div>
    );
  }
}
